<template><v-btn color="primary" @click="inc">
  Klicka här ({{count}})
</v-btn>
<p>
<script type="text/javascript" src="http://okhallen.web4u.nu/EventorAPI/loadepost.js"></script>
<script type="text/javascript" src="http://okhallen.web4u.nu/EventorAPI/get_persons_name_v8_mail.php"></script>
</p>
</template>
<script>export default {
  data: () => ({
    count: 1
  }),
  methods: {
    inc() {
      this.count++;
    }
  }
}</script>